// extracted by css-extract-rspack-plugin
export default {"panel":"dOERyc1tBUg9Q_kR","heading":"lmDMgAX_TIG_M71D","subtitle":"MzK3nnJVrisEFQA5"};